import {Controller} from '@hotwired/stimulus';

/**
 * Page de connexion : « Se connecter par e-mail » replie les autres moyens de connexion (classe `reducted`),
 * déploie le panneau du lien par e-mail (classe `deployed`) et masque les targets `hiddenWithEmail` ; « Retour »
 * rétablit le tout. Le choix est annoncé sur `window` (`sessions--login-methods:change`) : chaque instance
 * l'applique à ses propres targets, ce qui atteint les éléments placés hors du bloc (lien « Mot de passe perdu »).
 *
 *   <div {{ stimulus_controller('sessions--login-methods')
 *          |stimulus_action('sessions--login-methods', 'apply', 'sessions--login-methods:change@window') }}>
 *     <div {{ stimulus_target('sessions--login-methods', 'reducible') }}>
 *       <button {{ stimulus_action('sessions--login-methods', 'choose', 'click', {email: true}) }}>…</button>
 *     </div>
 *     <div {{ stimulus_target('sessions--login-methods', 'emailPanel') }}>
 *       <button {{ stimulus_action('sessions--login-methods', 'choose', 'click', {email: false}) }}>…</button>
 *     </div>
 *   </div>
 *   <p {{ stimulus_controller('sessions--login-methods')
 *        |stimulus_action('sessions--login-methods', 'apply', 'sessions--login-methods:change@window') }}>
 *     <a {{ stimulus_target('sessions--login-methods', 'hiddenWithEmail') }}>…</a>
 *   </p>
 */
export default class extends Controller {
  static targets = ['reducible', 'emailPanel', 'hiddenWithEmail'];

  choose({params: {email}}) {
    this.dispatch('change', {target: window, detail: {email}});
  }

  apply({detail: {email}}) {
    this.reducibleTargets.forEach((element) => element.classList.toggle('reducted', email));
    this.emailPanelTargets.forEach((element) => element.classList.toggle('deployed', email));
    this.hiddenWithEmailTargets.forEach((element) => {
      element.hidden = email;
    });
  }
}
